var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-medical-team.6d7a62cd.png","uri@2x": __webpack_public_path__ + "icon-medical-team.b74b34fb.png","uri@3x": __webpack_public_path__ + "icon-medical-team.87802074.png",
    width: 28,
    height: 34
});